export const Name = 'open-shade-picker';
export const OpenFeedShadePicker = Name;
export let ShadePickerMode = /*#__PURE__*/function (ShadePickerMode) {
  ShadePickerMode["Favorites"] = "favorites";
  ShadePickerMode["QuickBuy"] = "quickBuy";
  return ShadePickerMode;
}({});
//# sourceMappingURL=event.js.map